import './ButtonsContainer.css'

const ButtonsContainer = ({ children }) => {
  return <div className='buttonsContainer'>{children}</div>
}

export default ButtonsContainer
